/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const subtract_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M21 12H3"
    />
  </svg>
)
export default subtract_medium
